import React from "react";
import { TradeDrawerListItemSection } from "../styles";
import { useInfo24H } from "@app/hooks/trade/info24H";
import ListCoin from "./ListCoin";
import PriceHigh from "./PriceHigh";
import ListVolume from "./ListVolume";
import { useIndexPrice } from "@app/hooks/trade/indexprice";
import { goTo } from "@app/hooks/navigation";
import { useNavigate } from "react-router-dom";

const HISTORY_KEY = 'search_history';

const HeaderSearchItem = ({ item, index }: any) => {
  const navigation = useNavigate();
  //const { data: info24H } = useInfo24H(item?.id);

  const { getInfo24H } = useInfo24H();
  const info24H = getInfo24H(item?.id);

  const { getPrice } = useIndexPrice(item?.id);

  const handleClick = () => {
    // 히스토리에 저장
    try {
      const saved = localStorage.getItem(HISTORY_KEY);
      let history = saved ? JSON.parse(saved) : [];

      // 중복 제거
      history = history.filter((h: any) => h.id !== item.id);

      // 최근 항목을 맨 앞에 추가
      history.unshift({
        id: item.id,
        pairs: item.pairs,
        type: 'USDT Perpetual',
      });

      // 최대 10개까지만 저장
      history = history.slice(0, 10);

      localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
    } catch (e) {
      console.error('Failed to save search history', e);
    }

    // 페이지 이동
    location.href = `/trade/${item?.id}`;
  };

  return (
    <TradeDrawerListItemSection onClick={handleClick}>
      <ListCoin item={item} />
      <PriceHigh indexPrice={getPrice(item?.id)} info24H={info24H} />
      <ListVolume volume={info24H?.volume} />
    </TradeDrawerListItemSection>
  );
};

export default HeaderSearchItem;
